import { render, staticRenderFns } from "./PasswordSetupDialog.vue?vue&type=template&id=318f50cb&scoped=true"
import script from "./PasswordSetupDialog.vue?vue&type=script&lang=js"
export * from "./PasswordSetupDialog.vue?vue&type=script&lang=js"
import style0 from "./PasswordSetupDialog.vue?vue&type=style&index=0&id=318f50cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318f50cb",
  null
  
)

export default component.exports